import {SurveyResponseService} from "application/services/SurveyResponseService";
import {classifySubmitError} from "application/utils/submitErrors";
import {listPendingSubmissions, removePendingSubmission} from "application/utils/pendingSubmissions";

export interface FlushResult {
    enviados: string[];
    pendientes: string[];
}

export async function flushPendingSubmissions(): Promise<FlushResult> {
    const pendientes = listPendingSubmissions();
    const resultado: FlushResult = {enviados: [], pendientes: []};

    if (pendientes.length === 0) return resultado;

    console.info(`[pendientes] ${pendientes.length} envío(s) sin entregar; reintentando`);

    for (const payload of pendientes) {
        try {
            await SurveyResponseService.enviarGuia(payload);
            removePendingSubmission(payload.token);
            resultado.enviados.push(payload.token);
            console.info(`[pendientes] token ${payload.token} entregado`);
        } catch (error) {
            const {kind, retriable} = classifySubmitError(error);
            if (!retriable) {
                removePendingSubmission(payload.token);
                console.error(`[pendientes] token ${payload.token} descartado (${kind})`);
                continue;
            }
            resultado.pendientes.push(payload.token);
            console.warn(`[pendientes] token ${payload.token} sigue sin salir (${kind})`);
        }
    }

    return resultado;
}
